<template>
  <div class="top-bar-wrapper">
    <div class="content-width-1300">
      <div class="top-bar-left">
        <span id="pageSlogan" class="item-span">{{sloganContent}}</span>
      </div>
      <div class="top-bar-right is-login-bar" v-if="isLogin1">
        <span v-if="productType !== 3 && (!accountInfo || accountInfo.needBinding)" class="item-span" @click="_clickItem('binding-card')">立即绑卡</span>
        <span v-if="productType !== 3" class="item-span margin-0-36" @click="_clickItem('purchase')">在线购买</span>
        <el-dropdown class="el-dropdown-self" placement="bottom"  trigger="hover">
          <span class="item-span">{{accountInfo ? accountInfo.studentName : ''}}<i class="iconfont iconarrow-down"></i></span>
          
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="_clickItem('personal')">个人中心</el-dropdown-item>
            <el-dropdown-item @click.native="_clickItem('logout')">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="top-bar-right" v-else>
        <span v-if="productType !== 3" class="item-span" @click="_clickItem('purchase')">在线购买</span>
        <span v-if="productType !== 3" class="item-span" @click="_clickItem('register')">立即注册</span>
        <span class="item-span" @click="_clickItem('login')">登录</span>
      </div>
    </div>
  </div>
</template>
<script>
import { productType } from "config/config";
import { localStorageUtil, SloganContent } from 'utils/util';
import store from 'store';
import { mapState } from 'vuex';
export default {
  name: 'TopBar',
  data() {
    return {
      productType: 1,
      isLogin1: false,
      sloganContent: '',
    }
  },
  computed: {
    ...mapState(['accountInfo', 'isLogin'])
  },
  watch: {
    isLogin(val, oldVal) {
      this.isLogin1 = val;
      // this.isLogin1 = localStorageUtil.getItem('isLogin');
    },
    accountInfo: {
      deep: true,
      handler(val) {
        if(val) {
          // console.log('?????', val.status);
        }
      }
    }
  },
  methods: {
    _clickItem(type) {
      let _path = this.$route.path;
      if(type === 'purchase' && _path !== '/purchase' && _path !== '/purchase/product-details') {
        // _hmt.push(['_trackEvent', 'card', 'order', 'top bar', '']);
        let routeUrl = this.$router.resolve({
          path: "/purchase/product-details",
          query: {
            productId: 1
          }
        });
        window.open(routeUrl.href, '_blank');
        // this.win1 = window.open(routeUrl.href, _path); // 后续用 win1 这个引用执行 focus 方法
        // if (!this.win1.closed) {
        //   this.win1.focus();
        // }
      }else if(type === 'binding-card' && _path !== '/binding-card') {
        // _hmt.push(['_trackEvent', 'card', 'binding', 'top bar', '']);
        this.$router.push('/binding-card?type=1');
      }else if(type === 'register' && _path !== '/register') {
        this.$router.push('/register');
      }else if(type === 'login' && _path !== '/home-page') {
        this.$router.push('/home-page');
      }else if(type === 'login' && _path === '/home-page') {
        $('#loginNameRef').focus();
      }else if(type === 'personal' && _path !== '/personal-center/basic-info') {
        this.$router.push('/personal-center/basic-info');
      }else if(type === 'logout') {
        store.commit('LOGOUT', {});
        store.dispatch('setLogout');
        setTimeout(() => {
          if(_path !== '/home-page') {
            this.$router.push('/home-page');
          }
        }, 200);
        
      }
    }
  },
  created() {
    if (isNaN(productType)) {
      this.productType = 1;
    } else {
      this.productType = Number(productType);
    }
    this.isLogin1 = localStorageUtil.getItem('isLogin');
    this.sloganContent = SloganContent(this.$route.fullPath);

  }
}
</script>
<style lang="less">
@color-main: #03B2B2;
.top-bar-wrapper {
  width: 100%;
  height: 28px;
  line-height: 28px;
  background: #F6F6F6;
  font-size: 12px;
  .content-width-1300 {
    .item-span {
      color: #555555;
      cursor: pointer;
    }
    .top-bar-left {
      float: left;
      cursor: default;
      .item-span:hover {
        cursor: default;
      }
      
    }
    .margin-0-36 {
      margin: 0 36px !important;
    }
    .top-bar-right.is-login-bar {
      float: right;
      height: 28px;
      .el-dropdown-self {
        .item-span {
          margin: 0;
          font-size: 12px;
        }
        .iconarrow-down {
          font-size: 12px;
          margin-left: 6px;
          color: #555555;
          cursor: pointer;
        }
      }
    }
    .top-bar-right {
      float: right;
      .item-span {
        margin-left: 36px;
        margin-right: 0;
        &:hover {
          text-shadow: 0 0 2px #fff;
        }
      }
    }
  }
}
</style>